/* eslint-disable camelcase */
import { type UseMutationResult, useMutation } from 'react-query';

import {
  CustomReportsService,
  Wealthlane_ReportService_Dtos_CustomReport_CustomReportSaveAndRunResponseDto,
} from '@wealthlane/api-services/wealthlane-report-service';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import _ from 'lodash';

const normalizeSequenceNumbers = (buckets: any[] | undefined): any[] | undefined => {
  if (!buckets || !buckets.length) return buckets;
  const selected = buckets.filter((item: any) => item.isSelected !== false);
  const unselected = buckets.filter((item: any) => item.isSelected === false);
  const sorted = [...selected].sort((a, b) => (a.sequenceNumber ?? 0) - (b.sequenceNumber ?? 0));
  const normalized = sorted.map((item, index) => ({ ...item, sequenceNumber: index + 1 }));
  return [...normalized, ...unselected];
};

const transformPayload = (payload: Record<string, any>) => {
  const newPayload = {
    ...payload,
    requiredFieldBuckets: normalizeSequenceNumbers(
      payload.requiredFieldBuckets?.map((item: any) => ({
        ...item,
        userFieldFormats: item?.userFieldFormats?.map((format: any) => ({
          key: format.key,
          value: !_.isEmpty(format.value) ? format.value : format.placeholder,
          placeholder: format.placeholder,
        })),
      }))
    ),
    optionalFieldBuckets: normalizeSequenceNumbers(
      payload.optionalFieldBuckets?.map((item: any) => ({
        ...item,
        userFieldFormats: item?.userFieldFormats?.map((format: any) => ({
          key: format.key,
          value: !_.isEmpty(format.value) ? format.value : format.placeholder,
          placeholder: format.placeholder,
        })),
      }))
    ),
  };
  return newPayload;
};

const usePostSubmitAndRunDynamicReport = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  openSubmitModal: () => void,
  setTaskReferanceNo?: any
): UseMutationResult<
  Wealthlane_ReportService_Dtos_CustomReport_CustomReportSaveAndRunResponseDto | undefined,
  unknown,
  any,
  unknown
> => {
  return useMutation(
    async (payload: any) => {
      let newPayload = { ...payload, reportConfigurationId: payload.id };
      newPayload = transformPayload(newPayload);
      return await handleRequest(
        CustomReportsService.postApiReportApiAppCustomReportsSubmitAndRunReport(newPayload)
      );
    },
    {
      onSuccess: async (
        response:
          | Wealthlane_ReportService_Dtos_CustomReport_CustomReportSaveAndRunResponseDto
          | undefined
      ) => {
        if (response && response?.isSuccess === true) {
          openSubmitModal();
          setTaskReferanceNo(response.taskRefrenceNo);
        } else if (response && response?.error) {
          toast.error(<ToastComponent label='Error' message={`${response?.error[0]}`} />);
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostSubmitAndRunDynamicReport;
